import { Easing } from 'remotion';

// Themes
import { employeeYearInReviewTheme } from '@/components/EmployeeYearInReview/theme';

import { EntryAnimation, LineStyle, WaveConfig } from './types';

const {
  rawColors: { wavyLinesBackground },
} = employeeYearInReviewTheme;

/**
 * Default configuration values
 */
export const DEFAULT_WAVE_CONFIG: WaveConfig = {
  amplitude: 250,
  frequency: 0.002,
  speed: 0.03,
  segments: 100,
};

export const DEFAULT_LINE_STYLE: LineStyle = {
  strokeWidth: 65,
  color: wavyLinesBackground.lineColor,
  opacity: 1,
};

export const DEFAULT_ENTRY_ANIMATION: EntryAnimation = {
  duration: 180,
  easing: Easing.out(Easing.cubic),
};
